import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatTabsModule } from '@angular/material/tabs';
import { AlertDataService } from 'src/app/main/shared/services/alert-data.service';
import { QuickPanelService } from './quick-panel.service';
import { IAlert } from 'src/app/core/dto';
import { ScrollbarComponent } from '../../../@fury/shared/scrollbar/scrollbar.component';
import { AlertScheduleSlipComponent } from './alert-schedule-slip/alert-schedule-slip.component';
import { AlertWarehouseLateComponent } from './alert-warehouse-late/alert-warehouse-late.component';
import { AlertIntegrationErrorComponent } from './alert-integration-error/alert-integration-error.component';
import { AlertLicensingComponent } from './alert-licensing/alert-licensing.component';
import { AlertGeneralComponent } from './alert-general/alert-general.component';
import { AlertTruckLateComponent } from './alert-truck-late/alert-truck-late.component';
import { OrderByPipe } from 'src/app/main/shared/pipes/order-by.pipe';

@Component({
  selector: 'fury-quickpanel',
  templateUrl: './quickpanel.component.html',
  styleUrls: ['./quickpanel.component.scss'],
  imports: [
    FlexLayoutModule,
    MatTabsModule,
    ScrollbarComponent,
    AlertScheduleSlipComponent,
    AlertWarehouseLateComponent,
    AlertIntegrationErrorComponent,
    AlertLicensingComponent,
    AlertGeneralComponent,
    AlertTruckLateComponent,
    OrderByPipe
],
})
export class QuickpanelComponent implements OnInit {
  alerts: IAlert[] = [];

  constructor(
    private alertService: AlertDataService,
    private router: Router,
    private quickPanelService: QuickPanelService
  ) {
    this.alertService.alerts$.subscribe((alerts) => {
      this.alerts = alerts;
    });
  }

  gotoSettings() {
    this.router.navigate(['/settings/status']);
    this.quickPanelService.onSetOpen(false);
  }

  ngOnInit() {}
}
